import axios from 'axios'
import * as React from 'react'
import ButtonAction from 'components/shared/ButtonAction'
import { useState, useCallback } from 'react'
import { useTheme } from '@material-ui/core/styles'
import useCredentials from '../hooks/useCredentials'

const PublishButton: React.FC<{ id: string; className?: string }> = ({ className = '', id }) => {
  const { credentials } = useCredentials()
  const [loading, setLoading] = useState(false)
  const theme = useTheme()

  const handleClick = useCallback(async () => {
    try {
      setLoading(true)
      await axios.put(`/api/panel/organizations/${id}/publish_settings`, {}, { headers: credentials })
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }, [credentials, id])

  return (
    <ButtonAction
      text='Publish'
      className={className}
      type='button'
      onClick={handleClick}
      loading={loading}
      loaderColor={theme.palette.primary[600] || '#fff'}
    />
  )
}

export default PublishButton
